export const SERVER_EOS_MESSAGE =
  'We no longer offer sales and support for server apps. You can stay connected by exploring the migration options to either the cloud or Data Center version of this app.';

export const SERVER_EOL_MESSAGE_FOR_DATA_CENTER_SUPPORTED_APPS =
  'As new server app sales are no longer available on Atlassian Marketplace, you can use the Data Center version of this app to support server to cloud migration. The existing server app version can only be updated until the end of support for server on Feb 15,2024.';

export const SERVER_EOL_MESSAGE_FOR_NON_DATA_CENTER_SUPPORTED_APPS =
  'As we continue to move towards a cloud future together, new server app sales and installs are no longer available for customers. You can update app version via Atlassian Marketplace until the end of support for server on Feb 15, 2024.';

export const DATA_CENTER_EOS_MESSAGE_TITLE = 'Ascend to new heights with Atlassian Cloud.';

export const DATA_CENTER_EOS_MESSAGE_DESCRIPTION =
  'Data Center support (excl. Bitbucket) ends on March 28, 2029. Together, we’ll make this transition a success.';

export const EXPLORE_CLOUD_MIGRATION_LINK =
  'https://www.atlassian.com/migration/assess/journey-to-cloud';

export const DATA_CENTER_MIGRATION_LINK = 'https://www.atlassian.com/migration';
